import api from './api'

export function openDocumentFile(url, options = {}) {
    if (!url) {
        return
    }

    const { download = false, filename } = options
    const newTab = download ? null : window.open('', '_blank')

    api.get(url, { responseType: 'blob' })
        .then(response => {
            const blobUrl = URL.createObjectURL(response.data)

            if (download) {
                const link = document.createElement('a')
                link.href = blobUrl
                link.download = filename || url.split('/').pop().split('?')[0]
                document.body.appendChild(link)
                link.click()
                link.remove()
            } else if (newTab) {
                newTab.location.href = blobUrl
            } else {
                window.location.href = blobUrl
            }
        })
        .catch(() => {
            if (newTab) {
                newTab.close()
            }
        })
}
